import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Empty } from 'antd';

const MonthlyComparisonChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <Empty description="Nenhum dado encontrado" />;
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="period" />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip 
          formatter={(value, name) => {
            if (name === 'Lotes') return [value, 'Lotes'];
            if (name === 'Tambores') return [value, 'Tambores'];
            return value;
          }}
        />
        <Legend />
        <Bar 
          yAxisId="left"
          dataKey="totalBatches" 
          name="Lotes" 
          fill="#1890ff" 
          radius={[8, 8, 0, 0]} 
        />
        <Bar 
          yAxisId="right"
          dataKey="totalDrums" 
          name="Tambores" 
          fill="#52c41a" 
          radius={[8, 8, 0, 0]} 
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MonthlyComparisonChart;

